import { initQuantityInputs } from './components/quantity-input.js';
import AddToCartAjax from './components/add-to-cart-ajax.js';

/**
 * Run scripts on document ready
 */
document.addEventListener("DOMContentLoaded", () => {
    initQuantityInputs();
    new AddToCartAjax();
});